<template>
    <div>
        <template v-if="assetInfo.id != null">
            <div class="content-caption dashed">资产基础信息</div>
            <div class="simple-form flex col-4">
                <div class="form-group center">
                    <div class="form-label">
                        <label>资产描述全称</label>
                    </div>
                    <div class="form-value">
                        <span :title="assetInfo.title || '无' ">{{assetInfo.title || "无"}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>名称</label>
                    </div>
                    <div class="form-value">
                        <span :title="assetInfo.name || '无' ">{{assetInfo.name || "无"}}</span>
                    </div>
                </div>
                <div class="form-group center" v-if="assetInfo.assetType == 0">
                    <div class="form-label">
                        <label>保内</label>
                    </div>
                    <div class="form-value">
                        <span class="font-red" v-if="assetInfo.wrntDueTime != null && new Date(assetInfo.currentTime).getTime() > new Date(assetInfo.wrntDueTime).getTime()">否</span>
                        <span class="font-green" v-if="assetInfo.wrntDueTime == null || new Date(assetInfo.currentTime).getTime() <= new Date(assetInfo.wrntDueTime).getTime()">是</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>型号</label>
                    </div>
                    <div class="form-value">
                        <span :title="assetInfo.model || '无' ">{{assetInfo.model || "无"}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>规格</label>
                    </div>
                    <div class="form-value">
                        <span :title="assetInfo.fixedSpec || '无' ">{{assetInfo.fixedSpec || "无"}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>分类</label>
                    </div>
                    <div class="form-value">
                        <span :title="assetInfo.catName || '无' ">{{assetInfo.catName || "无"}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>业务标签</label>
                    </div>
                    <div class="form-value">
                        <template v-for="tagName in assetInfo.tagNames">
                            <span class="swb-tags swb-tags-success mr5">{{tagName}}</span>
                        </template>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>维保分组</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetInfo.devcGroupFullName || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>品牌</label>
                    </div>
                    <div class="form-value">
                        <span :title="assetInfo.brandName || '无' ">{{assetInfo.brandName || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>系统编号</label>
                    </div>
                    <div class="form-value">
                        <span :title="assetInfo.tmpNo || '无' ">{{assetInfo.tmpNo || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>资产编号</label>
                    </div>
                    <div class="form-value">
                        <span :title="assetInfo.innerCode || '无' ">{{assetInfo.innerCode || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center" v-if="assetInfo.assetType == 0">
                    <div class="form-label">
                        <label>统一商品代码(UPC)</label>
                    </div>
                    <div class="form-value">
                        <span :title="assetInfo.upc || '无' ">{{assetInfo.upc || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center" v-if="assetInfo.assetType == 0">
                    <div class="form-label">
                        <label>供应商编码</label>
                    </div>
                    <div class="form-value">
                        <span :title="assetInfo.vendorCreditCode || '无' ">{{assetInfo.vendorCreditCode || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center" v-if="assetInfo.assetType == 0">
                    <div class="form-label">
                        <label>厂商序列号</label>
                    </div>
                    <div class="form-value">
                        <span :title="assetInfo.vendorSn || '无' ">{{assetInfo.vendorSn || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center" v-if="assetInfo.assetType == 0">
                    <div class="form-label">
                        <label>需要控温</label>
                    </div>
                    <div class="form-value">
                        <span :title="assetInfo.temperFlag ? '需要' : '不需要' ">{{assetInfo.temperFlag ? '需要' : '不需要'}}</span>
                    </div>
                </div>
                <div class="form-group center" v-if="assetInfo.temperFlag">
                    <div class="form-label">
                        <label>温度低值(°c)</label>
                    </div>
                    <div class="form-value">
                        <span :title="assetInfo.temperLow || '无' ">{{assetInfo.temperLow || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center" v-if="assetInfo.temperFlag">
                    <div class="form-label">
                        <label>温度高值(°c)</label>
                    </div>
                    <div class="form-value">
                        <span :title="assetInfo.temperHigh || '无'">{{assetInfo.temperHigh || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>财务类别</label>
                    </div>
                    <div class="form-value">
                        <span :title="assetInfo.assetKindName || '无' ">{{assetInfo.assetKindName || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>关联定义</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetInfo.devcDefId == -1 ? '未关联' : '已关联'}}</span>
                    </div>
                </div>
                <div class="form-group center" v-if="assetInfo.assetType == 0">
                    <div class="form-label">
                        <label>使用模式</label>
                    </div>
                    <div class="form-value">
                        <span>{{useModeMap[assetInfo.useMode]}}</span>
                    </div>
                </div>
                <div class="form-group center" v-if="assetInfo.assetType == 0">
                    <div class="form-label">
                        <label>需巡查</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetInfo.patrolFlag ? '是' : '否'}}</span>
                    </div>
                </div>
                <div class="form-group center" v-if="assetInfo.assetType == 0">
                    <div class="form-label">
                        <label>需保养</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetInfo.maintFlag ? '是' : '否'}}</span>
                    </div>
                </div>
                <div class="form-group center" v-if="assetInfo.assetType == 0">
                    <div class="form-label">
                        <label>需检验</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetInfo.inspectFlag ? '是' : '否'}}</span>
                    </div>
                </div>
                <div class="form-group center" v-if="assetInfo.assetType == 0">
                    <div class="form-label">
                        <label>需安装</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetInfo.setupFlag ? '是' : '否'}}</span>
                    </div>
                </div>
                <div class="form-group center" v-if="assetInfo.assetType == 0">
                    <div class="form-label">
                        <label>可维修</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetInfo.repairFlag ? '是' : '否'}}</span>
                    </div>
                </div>
            </div>
            <div class="content-caption dashed">财务信息</div>
            <div class="simple-form flex col-4">
                <div class="form-group center">
                    <div class="form-label">
                        <label>入账方式</label>
                    </div>
                    <div class="form-value">
                        <span>{{acctEnterWayMap[assetInfo.acctEnterWay]}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>财务在账</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetInfo.fiscalAcctFlag == 1 ? '是' : '否'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>不入账</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetInfo.fiscalIgnored ? '是' : '否'}}</span>
                    </div>
                </div>
                <div class="form-group center" v-if="assetInfo.assetType == 0">
                    <div class="form-label">
                        <label>已入账</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetInfo.fiscalInFlag ? '是' : '否'}}</span>
                    </div>
                </div>
                <div class="form-group center" v-if="assetInfo.assetType == 0">
                    <div class="form-label">
                        <label>已出账</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetInfo.fiscalOutFlag ? '是' : '否'}}</span>
                    </div>
                </div>
                <div class="form-group center" v-if="assetInfo.assetType == 0">
                    <div class="form-label">
                        <label>闲置</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetInfo.assetIdleX ? '是' : '否'}}</span>
                    </div>
                </div>
                <div class="form-group center" v-if="assetInfo.assetType == 1">
                    <div class="form-label">
                        <label>闲置数量</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetInfo.idleQuantity}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>原值(元)</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetInfo.orgWorth == null ? '无' : assetInfo.orgWorth.toFixed(2)}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>净值(元)</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetInfo.netWorth == null ? '无' : assetInfo.netWorth.toFixed(2)}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>折旧完毕</label>
                    </div>
                    <div class="form-value">
                        <span class="font-red" v-if="assetInfo.deprOver">是</span>
                        <span v-else>否</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>残值率(%)</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetInfo.rmnWorthRatio || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>使用年限(月)</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetInfo.durableLife || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>已用年限(月)</label>
                    </div>
                    <div class="form-value">
                        <span v-if="assetInfo.fiscalAcctFlag == 0">{{assetInfo.durableYears || 0}}</span>
                        <span v-else-if="assetInfo.deprable">{{(assetInfo.durableLife - assetInfo.leftMonths) || 0}}</span>
                        <span v-else></span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>首次购置</label>
                    </div>
                    <div class="form-value">
                        <span v-if="assetInfo.receiveTime != null">{{new Date(assetInfo.receiveTime).format("yyyy-MM-dd HH:mm:ss")}}</span>
                        <span v-else>无</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>当月折旧(元)</label>
                    </div>
                    <div class="form-value">
                        <span v-if="assetInfo.currentMonthDepr != null">{{(assetInfo.currentMonthDepr).toFixed(2)}}</span>
                        <span v-else>无</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>累计折旧(元)</label>
                    </div>
                    <div class="form-value">
                        <span>{{(assetInfo.aggtDeprWorth || 0).toFixed(2)}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>计划外折旧(元)</label>
                    </div>
                    <div class="form-value">
                        <span>{{(assetInfo.extraWorth || 0).toFixed(2)}}</span>
                    </div>
                </div>
            </div>
            <div class="content-caption dashed">库存信息</div>
            <div class="simple-form flex col-4">
                <div class="form-group center">
                    <div class="form-label">
                        <label>业务单元</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetInfo.retailerBizUnitName || "无"}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>部门全称</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetInfo.retailerComFullName || "无"}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>实体公司代码</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetInfo.retailerRealComCode || ""}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>机构标签</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetInfo.retailerShopTagName || "无"}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>仓库名称</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetInfo.warehouseName || "无"}}</span>
                    </div>
                </div>
                <div class="form-group center" v-if="assetInfo.assetType == 0">
                    <div class="form-label">
                        <label>在库</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetInfo.inStkQuantity > 0 ? '是' : '否'}}</span>
                    </div>
                </div>
                <div class="form-group center" v-if="assetInfo.assetType == 1">
                    <div class="form-label">
                        <label>在库数量</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetInfo.inStkQuantity || 0}}</span>
                    </div>
                </div>
                <div class="form-group center" v-if="assetInfo.assetType == 0">
                    <div class="form-label">
                        <label>账面不符</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetInfo.indoubtFlag == 1 ? '是' : '否'}}</span>
                    </div>
                </div>
            </div>
            <div class="content-caption dashed">管理信息</div>
            <div class="simple-form flex col-4">
                <div class="form-group center">
                    <div class="form-label">
                        <label>责任部门</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetInfo.respblDepartFullName || "无"}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>责任人</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetInfo.respblStaffName || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>领用部门</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetInfo.applyUseDepartFullName || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>领用人</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetInfo.applyUseStaffName || '无'}}</span>
                    </div>
                </div>
            </div>
            <div class="content-caption dashed">合约信息</div>
            <div class="simple-form flex col-4">
                <div class="form-group center">
                    <div class="form-label">
                        <label>初始合同编号</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetInfo.initContractNo || "无"}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>质保开始时间</label>
                    </div>
                    <div class="form-value">
                        <span v-if="assetInfo.wrntStartTime != null">{{new Date(assetInfo.wrntStartTime).format("yyyy-MM-dd HH:mm:ss")}}</span>
                        <span v-else>无</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>质保期(月)</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetInfo.wrntPeriod || '0'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>质保到期时间</label>
                    </div>
                    <div class="form-value">
                        <span v-if="assetInfo.wrntDueTime != null">{{new Date(assetInfo.wrntDueTime).format("yyyy-MM-dd HH:mm:ss")}}</span>
                        <span v-else>无</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>收货时间</label>
                    </div>
                    <div class="form-value">
                        <span v-if="assetInfo.receiveTime != null">{{new Date(assetInfo.receiveTime).format("yyyy-MM-dd HH:mm:ss")}}</span>
                        <span v-else>无</span>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="assetDtl.id != null">
            <div class="content-caption dashed">资产清单信息</div>
            <div class="simple-form flex col-4">
                <div class="form-group center">
                    <div class="form-label">
                        <label>公司代码</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetDtl.retailerRealComCode}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>资产编号</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetDtl.innerCode}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>资产描述</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetDtl.title}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>品牌型号</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetDtl.brandModel}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>财务类别</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetDtl.assetKindName}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>财务类别编码</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetDtl.assetKindCode}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>成本中心</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetDtl.costCenterCode}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>数量</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetDtl.quantity}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>单位</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetDtl.theUnit}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>验收日期</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetDtlDateToViewModel(assetDtl.receiptDate)}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>验收单自有编号</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetDtl.receiptInnerNo}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>入账日期</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetDtlDateToViewModel(assetDtl.fiscalInDate)}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>使用年限(月)</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetDtl.durableLife}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>资产原值(元)</label>
                    </div>
                    <div class="form-value">
                        <span>{{(assetDtl.orgWorth || 0).toFixed(2)}}</span>
                    </div>
                </div>
                <!--<div class="form-group center">-->
                <!--<div class="form-label">-->
                <!--<label>当月折旧(元)</label>-->
                <!--</div>-->
                <!--<div class="form-value">-->
                <!--<span>{{assetDtl.lastDeprWorth}}</span>-->
                <!--</div>-->
                <!--</div>-->
                <div class="form-group center">
                    <div class="form-label">
                        <label>累计折旧(元)</label>
                    </div>
                    <div class="form-value">
                        <span>{{(assetDtl.aggtDeprWorth || 0).toFixed(2)}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>计划外折旧(元)</label>
                    </div>
                    <div class="form-value">
                        <span>{{(assetDtl.lastDeprAdjustExtraWorth || 0).toFixed(2)}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>资产净值(元)</label>
                    </div>
                    <div class="form-value">
                        <span>{{(assetDtl.netWorth || 0).toFixed(2)}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>责任人</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetDtl.principalName}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>使用状态</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetDtl.useStateName}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>资产属性</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetDtl.assetNatureName}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>入账方式</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetDtl.acctEnterWayName}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>出账方式</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetDtl.acctOutWayName}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>外部系统编号</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetDtl.innerNo}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>报废/弃用</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetDtl.scrappedName}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>来源方式</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetDtl.receiptVoucherTypeName}}</span>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import {Utils, $} from '../../app.base'
    import {Vue, MsgBox, DomSizeWatcher, Routes, getComnMerchantBizTag} from '../../app.vues'
    //
    import devcApi from '../../api/devc'
    //
    let bizTagObj = null;
    export default {
        name: 'swb-assert-fiscal-info',
        desc: '资产明细',
        props: {
            innerCode: {
                type: String,
                default: null
            },
            assetType: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                assetInfo: {},
                assetDtl: {},
                acctEnterWayMap: getEnumMap("acctEnterWay", "value2text"),
                deprResultMap: getEnumMap("resultState", "value2text"),
                useModeMap: getEnumMap("devcUseMode", "value2text"),
            }
        },
        created: function () {
            bizTagObj = getComnMerchantBizTag();
            if (!Utils.isNoB(this.innerCode)) {
                this.getAssetInfo();
            }
        },
        mounted() {
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if (domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            getAssetInfo: function () {
                let self = this;
                let params = {
                    innerCode: self.innerCode,
                    assetType: self.assetType
                };
                //
                let msgBoxDlg = MsgBox.loading();
                devcApi.getAssetInfoByInnerCode(params, function (result) {
                    msgBoxDlg.close();
                    if (result.type == 'info') {
                        let resultMap = result.data || {};
                        let assetInfo = resultMap.assetInfo || {};
                        //
                        if (!Utils.isNoB(assetInfo.bizTag)) {
                            let bizTag = assetInfo.bizTag;
                            let tagIdList = [];
                            if (!Utils.isNoB(bizTag)) {
                                if (bizTag.indexOf("|") >= 0) {
                                    bizTag = bizTag.substring(1, bizTag.length - 1);
                                    tagIdList = bizTag.split("|") || [];
                                } else {
                                    tagIdList.push(bizTag);
                                }
                            }
                            let tagNames = [];
                            for (let i = 0; i < tagIdList.length; i++) {
                                let tagId = tagIdList[i];
                                let tagName = bizTagObj.getBizTagNameById(tagId);
                                if (!Utils.isNoB(tagName)) {
                                    tagNames.push(tagName);
                                }
                            }
                            assetInfo.tagNames = tagNames;
                        }
                        self.assetInfo = Utils.merge({}, assetInfo);
                        //
                        let assetDtl = resultMap.assetDtl || {};
                        self.assetDtl = Utils.merge({}, assetDtl);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            assetDtlDateToViewModel(dateInt){
                if (dateInt == null || dateInt == 0) {
                    return '';
                } else {
                    let dateStr = dateInt + '';
                    let nian = dateStr.substring(0, 4);
                    let yue = dateStr.substring(4, 6);
                    let ri = dateStr.substring(6, 8);
                    return nian + '-' + yue + '-' + ri;
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/AssetFiscalInfo.vue